var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { BotInstruction } from 'packages/bot/entities/BotInstruction';
import { BotAction } from 'packages/bot/entities/BotAction';
var BotNode = /** @class */ (function (_super) {
    __extends(BotNode, _super);
    function BotNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.entry = null;
        _this.type = null;
        _this.instructions = {};
        _this.actions = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.metadata = {};
        return _this;
    }
    Object.defineProperty(BotNode.prototype, "doesBranch", {
        get: function () {
            var _a;
            return !!((_a = this.actions) === null || _a === void 0 ? void 0 : _a.find(function (action) { return action.type === 'branch'; }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BotNode.prototype, "isEndNode", {
        get: function () {
            var _a;
            return !!((_a = this.actions) === null || _a === void 0 ? void 0 : _a.find(function (action) { return action.type === 'end'; }));
        },
        enumerable: false,
        configurable: true
    });
    BotNode.prototype.branchTo = function (uuid) {
        var _a, _b;
        var branchAction = (_a = this.actions) === null || _a === void 0 ? void 0 : _a.find(function (action) { return action.type === 'branch'; });
        if (!branchAction) {
            branchAction = new BotAction();
            branchAction.type = 'branch';
            branchAction.data = {};
            this.actions = (_b = this.actions) !== null && _b !== void 0 ? _b : [];
            this.actions.push(branchAction);
        }
        branchAction.data.default = uuid;
    };
    BotNode.prototype.branchFromOption = function (optionId, nextNodeId) {
        var _a, _b;
        var branchAction = (_a = this.actions) === null || _a === void 0 ? void 0 : _a.find(function (action) { return action.type === 'branch'; });
        if (!branchAction) {
            branchAction = new BotAction();
            branchAction.type = 'branch';
            branchAction.data = {};
            this.actions = (_b = this.actions) !== null && _b !== void 0 ? _b : [];
            this.actions.push(branchAction);
        }
        if (!branchAction.data.conditions) {
            branchAction.data.conditions = [];
        }
        branchAction.data.conditions.push({ match: optionId, next: nextNodeId });
    };
    Object.defineProperty(BotNode.prototype, "instructionList", {
        get: function () {
            var instructions = [];
            var next = this.entry;
            while (next) {
                var instruction = EntityBuilder.buildOne(BotInstruction, this.instructions[next]);
                instructions.push(instruction);
                (next = instruction.next);
            }
            return instructions;
        },
        set: function (list) {
            this.instructions = list.reduce(function (obj, instruction) {
                if (instruction.id) {
                    obj[instruction.id] = instruction;
                }
                return obj;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Type(Object),
        __metadata("design:type", Object)
    ], BotNode.prototype, "instructions", void 0);
    __decorate([
        Type(BotAction),
        __metadata("design:type", Array)
    ], BotNode.prototype, "actions", void 0);
    __decorate([
        Type(Object),
        __metadata("design:type", Object)
    ], BotNode.prototype, "metadata", void 0);
    return BotNode;
}(Entity));
export { BotNode };
